import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { TextFormat, Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './daily-product-usage.reducer';

export const DailyProductUsageDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const dailyProductUsageEntity = useAppSelector(state => state.dailyProductUsage.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="dailyProductUsageDetailsHeading">
          <Translate contentKey="crawlerBackendApp.dailyProductUsage.detail.title">DailyProductUsage</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{dailyProductUsageEntity.id}</dd>
          <dt>
            <span id="price">
              <Translate contentKey="crawlerBackendApp.dailyProductUsage.price">Price</Translate>
            </span>
          </dt>
          <dd>{dailyProductUsageEntity.price}</dd>
          <dt>
            <span id="from">
              <Translate contentKey="crawlerBackendApp.dailyProductUsage.from">From</Translate>
            </span>
          </dt>
          <dd>
            {dailyProductUsageEntity.from ? (
              <TextFormat value={dailyProductUsageEntity.from} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="util">
              <Translate contentKey="crawlerBackendApp.dailyProductUsage.util">Util</Translate>
            </span>
          </dt>
          <dd>
            {dailyProductUsageEntity.util ? (
              <TextFormat value={dailyProductUsageEntity.util} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="dailyUsage">
              <Translate contentKey="crawlerBackendApp.dailyProductUsage.dailyUsage">Daily Usage</Translate>
            </span>
          </dt>
          <dd>{dailyProductUsageEntity.dailyUsage}</dd>
          <dt>
            <Translate contentKey="crawlerBackendApp.dailyProductUsage.product">Product</Translate>
          </dt>
          <dd>{dailyProductUsageEntity.product ? dailyProductUsageEntity.product.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/daily-product-usage" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/daily-product-usage/${dailyProductUsageEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default DailyProductUsageDetail;
